// extracted by mini-css-extract-plugin
module.exports = {"Tab":"tab-v2_Tab__e_mTG","activeTab":"tab-v2_activeTab__Z4wEA"};